import { ReviewScannedInvoiceActivity } from '@melio/ap-activities';

import { useRouter } from '@/hooks/router.hooks';
import { ScannedInvoiceFilePreview } from '@/widgets/pay-dashboard/review-scanned-invoice/components/ScannedInvoiceFilePreview';
import { MarkAsPaidDialog } from '../bill-details/components/MarkAsPaidDialog';

export const NewReviewScannedInvoiceScreen = ({ scannedInvoiceId }: { scannedInvoiceId: string }) => {
  const { navigateToSchedulePayment, generateNPEDashboardLink } = useRouter();

  const onSchedulePayment = (billId: string) => {
    navigateToSchedulePayment({ billId, returnUrl: generateNPEDashboardLink('payments') });
  };

  return (
    <ReviewScannedInvoiceActivity
      scannedInvoiceId={scannedInvoiceId}
      goToSchedulePayment={onSchedulePayment}
      markAsPaidDialog={MarkAsPaidDialog}
      invoicePreview={ScannedInvoiceFilePreview}
    />
  );
};
